import {UIComponent} from "@webfruits/core";
import {CoreServices} from "../../core/CoreServices";
import {FactInfo} from "./components/FactInfo";
import {gsap} from "gsap";
import {Size} from "../../style/Size";
import {PromisedDelay} from "@webfruits/toolbox/dist/timer/PromisedDelay";
import {AppConfig} from "../../config/AppConfig";

/******************************************************************
 * FactSystem
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class FactSystem extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _factInfo: FactInfo;
    private _latestMouseX: number = 0;
    private _latestMouseY: number = 0;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _core: CoreServices) {
        super("fact-system");
        this.initFactInfo();
        this.initListeners();
        this._core.state.HOVERED_HOTSPOT.onChangeSignal.add(() => this.onHoveredHotspotChanged());
        this._core.state.SELECTED_HOTSPOT.onChangeSignal.add(() => this.onSelectHotspotChanged());
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public updateStyles() {
        this.applyStyle({
            pointerEvents: "none",
            userSelect: "none",
            webkitTouchCallout: "none",
            position: "absolute",
            top: 0,
            left: 0
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initFactInfo() {
        this._factInfo = new FactInfo();
        this.addChild(this._factInfo);
    }

    private initListeners() {
        window.addEventListener("mousemove", (e: MouseEvent) => this.onMouseMoved(e));
    }

    private updateFactInfo() {
        if (!this._core.state.HOVERED_HOTSPOT.hasValue()
            || this._core.state.SELECTED_HOTSPOT.hasValue()) {
            this._factInfo.setHotspot(null)
            return;
        }
        this._factInfo.setHotspot(this._core.state.HOVERED_HOTSPOT.getValue())
    }

    private updateFactInfoPosition() {
        const baseLeft = this._latestMouseX + 10;
        const baseTop = this._latestMouseY + 10;
        let offsetLeft = Size.APP_WIDTH - (baseLeft + this._factInfo.width + 10);
        let offsetTop = Size.APP_HEIGHT - (baseTop + this._factInfo.height + 10);
        if (offsetLeft > 0) {
            offsetLeft = 0;
        }
        if (offsetTop > 0) {
            offsetTop = 0;
        }
        gsap.to(this._factInfo.view, {
            duration: 0.2,
            left: baseLeft + offsetLeft,
            top: baseTop + offsetTop,
            ease: "power4.out"
        })
    }

    /******************************************************************
     * Events
     *****************************************************************/

    private async onHoveredHotspotChanged() {
        this.updateFactInfo();
        this._factInfo.updateVisibility();
        await PromisedDelay.wait(AppConfig.FACT_INFO_SHOW_DELAY);
        this.updateFactInfoPosition();

    }

    private onMouseMoved(e: MouseEvent) {
        this._latestMouseX = e.clientX;
        this._latestMouseY = e.clientY;
        this.updateFactInfoPosition();
    }

    private onSelectHotspotChanged() {
        this.updateFactInfo();
    }
}
